@tailwind base;
@tailwind components;
@tailwind utilities;

/* :host rules only — the menu flyout is absolutely positioned relative to
   the host, which must itself be block + positioned. Tailwind utilities
   cannot target the shadow host, so these two declarations live here. */
:host {
  display: block;
  position: relative;
}
